

































































import Vue from "vue";
import Consent from "@/api/models/Consent";
import ConsentResponse from "@/api/models/ConsentResponse";
import Locale from "@/data/locale";

export default Vue.extend({
  name: "c-consent",
  props: {
    consent: {
      type: Object as () => Consent
    },

    active: {
      required: true,
      default: false
    }
  },

  data () {
    return {
      stringResponse: undefined as string | undefined,
      currentResponses: [] as Array<ConsentResponse>,
      localeIt: Locale.QInputDateLocaleIt,
      booleanResponse: undefined as boolean | undefined
    };
  },

  computed: {
    fallbackResponse (): string {
      // Forse ha una risposta di quelle vecchie, senza una vera "risposta", ma la stringozza
      // buttata là nella customer_consent direttamente.
      return this.consent.customer_consent?.document_consent_response_description ||
      this.consent.definition.default_response_value ||
      "---";
    },

    type (): string | null {
      return this.consent.definition.field_type;
    },

    isCheckboxRender (): boolean {
      return this.type === null || ["checkboxes", "radio", "boolean", ""].includes(this.type);
    }
  },

  watch: {
    stringResponse: function () {
      this.notifyValue();
    },
    booleanResponse: function () {
      this.notifyValue();
    }
  },

  methods: {
    reset () {
      this.currentResponses = [];
      this.stringResponse = undefined;
      this.booleanResponse = undefined;

      if (this.consent.customer_consent) {
        this.tryPushResponse(this.consent.customer_consent.document_consent_response_definition_id);

        // Può essere un JSON array di Id...
        // Che possono puntare o a "result" o ad "id"...
        try {
          const descriptionIds = JSON.parse(this.consent.customer_consent.document_consent_response_description);
          if (descriptionIds.constructor === Array) {
            descriptionIds.forEach(this.tryPushResponse);
          }
        } catch (error) {}

        // A volte viene usata description => result come una sorta di Id... non ho capito.
        this.tryPushResponse(this.consent.customer_consent.document_consent_response_description);

        // Altri casi, è un valore libero.
        this.stringResponse = this.consent.customer_consent.document_consent_response_description;
        this.booleanResponse = this.consent.customer_consent.document_consent_response_description === "1";

        this.notifyValue();
      }
    },

    tryGetResponse (id: string | number) {
      const results = this.consent.definition.responses
        .filter(response => response.id?.toString() === id?.toString() || response.result?.toString() === id?.toString());
      if (results.length === 1) {
        return results[0];
      }

      return undefined;
    },

    tryPushResponse (id: string | number) {
      const response = this.tryGetResponse(id);
      if (response) {
        this.currentResponses.push(response);
      }
    },

    isSelected (consentResponse: ConsentResponse) {
      return this.currentResponses
        .filter(response => this.areSame(response, consentResponse))
        .length > 0;
    },

    areSame (consentResponse: ConsentResponse, other: ConsentResponse) {
      return (consentResponse.id || consentResponse.result)?.toString() === (other.id || other.result)?.toString();
    },

    deselect (consentResponse: ConsentResponse) {
      this.currentResponses = this.currentResponses
        .filter(selected => !this.areSame(selected, consentResponse));
    },

    select (consentResponse: ConsentResponse) {
      this.deselect(consentResponse);
      this.currentResponses.push(consentResponse);
    },

    onSelected (consentResponse: ConsentResponse) {
      // Se è a tipo singolo, deseleziono tutto prima, e poi seleziono,
      // inoltre ignoro eventuali richieste di deselezione.
      if (this.type === null || ["select", "radio", ""].includes(this.type)) {
        if (this.isSelected(consentResponse)) {
          return;
        }

        this.currentResponses = [];
        this.select(consentResponse);
      }

      // Se è scelta multipla, la cosa più tranquillina.
      if (this.type === "checkboxes" || this.type === "multi_select" || this.type === "boolean") {
        if (this.isSelected(consentResponse)) {
          this.deselect(consentResponse);
        } else {
          this.select(consentResponse);
        }
      }

      this.notifyValue();
    },

    notifyValue () {
      const event = "change";

      switch (this.type) {
        case null:
        case "select":
        case "radio":
        case "":
          this.$emit(event, {
            consent: this.consent.definition.id.toString(),
            response: this.currentResponses.map(response => (response.id || response.result)?.toString())[0]
          });
          break;

        case "boolean":
          this.$emit(event, {
            consent: this.consent.definition.id.toString(),
            response: "" + this.booleanResponse + ""
          });
          break;

        case "checkboxes":
        case "multi_select":
          this.$emit(event, {
            consent: this.consent.definition.id.toString(),
            response: "[" + this.currentResponses.map(response => (response.id || response.result)?.toString()).join(", ") + "]"
          });
          break;

        case "time":
        case "text":
        case "date":
        case "decimal":
        case "double":
        case "integer":
          this.$emit(event, {
            consent: this.consent.definition.id.toString(),
            response: this.stringResponse
          });
          break;

        default:
          break;
      }
    }
  },

  mounted () {
    this.reset();
  }
});
